export default "__VITE_ASSET__a840de18__"